'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('fpx'),
    isFunction = _require.isFunction,
    validate = _require.validate;

var _require2 = require('./observable'),
    isObservable = _require2.isObservable;

var _require3 = require('./ref'),
    isRef = _require3.isRef;

var _require4 = require('./subscription'),
    isSubscription = _require4.isSubscription;

var _require5 = require('./lifetime'),
    _deinit = _require5.deinit;

var _require6 = require('./utils'),
    flushBy = _require6.flushBy;

var Reaction = function () {
  function Reaction() {
    _classCallCheck(this, Reaction);

    this.nextContext = null;
    this.lastContext = null;
    this.deref = this.deref.bind(this);
  }

  Reaction.prototype.deref = function deref(ref) {
    validate(isRef, ref);
    if (this.nextContext && isObservable(ref)) this.nextContext.subscribeTo(ref);
    return ref.deref();
  };

  Reaction.prototype.run = function run(fun, onTrigger) {
    validate(isFunction, fun);
    validate(isFunction, onTrigger);

    if (this.nextContext) throw Error('Unexpected overlapping .run()');

    this.nextContext = new ReactionContext(this, onTrigger);

    try {
      return fun(this);
    } finally {
      var nextContext = this.nextContext,
          lastContext = this.lastContext;

      this.lastContext = nextContext;
      this.nextContext = null;
      if (lastContext) lastContext.deinit();
    }
  };

  // TODO document


  Reaction.prototype.loop = function loop(fun) {
    var _this = this;

    validate(isFunction, fun);
    var loop = function loop() {
      _this.run(fun, loop);
    };
    loop();
  };

  Reaction.prototype.deinit = function deinit() {
    var nextContext = this.nextContext,
        lastContext = this.lastContext;

    try {
      if (nextContext) nextContext.deinit();
    } finally {
      if (lastContext) lastContext.deinit();
    }
  };

  Reaction.loop = function loop(fun) {
    validate(isFunction, fun);
    var reaction = new this();
    try {
      reaction.loop(fun);
      return reaction;
    } catch (err) {
      reaction.deinit();
      throw err;
    }
  };

  return Reaction;
}();

exports.Reaction = Reaction;

var ReactionContext = function () {
  function ReactionContext(reaction, onTrigger) {
    _classCallCheck(this, ReactionContext);

    this.state = this.states.PENDING;
    this.reaction = reaction;
    this.onTrigger = onTrigger;
    this.trigger = this.trigger.bind(this);
    this.subscriptions = [];
  }

  ReactionContext.prototype.subscribeTo = function subscribeTo(observable) {
    if (this.state === this.states.PENDING) {
      var sub = observable.subscribe(this.trigger);
      validate(isSubscription, sub);
      this.subscriptions.push(sub);
    }
  };

  ReactionContext.prototype.trigger = function trigger() {
    if (this.state === this.states.PENDING) {
      this.state = this.states.TRIGGERED;
      this.onTrigger.call(null, this.reaction);
    }
  };

  ReactionContext.prototype.deinit = function deinit() {
    this.state = this.states.DEAD;
    flushBy(this.subscriptions, _deinit);
  };

  return ReactionContext;
}();

ReactionContext.prototype.states = {
  PENDING: 'PENDING',
  TRIGGERED: 'TRIGGERED',
  DEAD: 'DEAD'
};


//////////////////
// WEBPACK FOOTER
// ./~/espo/dist/reaction.js
// module id = 912
// module chunks = 118